export const links = [
    { href: 'https://github.com/CriticalElement', src: '/github.svg', alt: 'github' },
    { href: 'https://linkedin.com/in/pranav-pakanati', src: '/linkedin.svg', alt: 'linkedin' },
    { href: 'mailto:pranav.pakanati@gmail.com', src: '/alternate_email.svg', alt: 'email' },
    { href: `${window.location.protocol}//${window.location.host}/resume.pdf`, src: '/contact_page.svg', alt: 'resume' },
    { href: 'tel:214-604-6407', src: '/phone.svg', alt: 'phone' },
    { href: 'sms:214-604-6407', src: '/sms.svg', alt: 'sms' }
];

type ProjectInfo = { src: string, projectType: string, title: string, description: string };
export const projects: ProjectInfo[] = [
    { src: 'https://spotalong.github.io/static/Group%201.png', projectType: 'Desktop App', title: 'SpotAlong', description: 'Listen along to your friends in Spotify, without needing Premium.' },
    { src: '/edu4need-splash.png', projectType: 'App', title: 'Edu4Need', description: 'Donate to kids in need with a crowdfunding platform personalized to each and every student and donor.' },
    { src: '/game-day-grill-splash.png', projectType: 'Website', title: 'Game Day Grill', description: 'This mock restaurant website has a functioning cart, reservation, payments and delivery system.' },
    { src: '/nixar.png', projectType: 'Website', title: 'Nixar Solutions', description: 'This website was developed for Nixar Solutions, a social media marketing company out of California.' }
];

const detailedDescriptions: Record<string, string> = {
    'SpotAlong': 'Spotify already has a built-in friend activity tab in their desktop app; but for many, this feature is not well implemented and unwieldy to use. This is why SpotAlong was created- to have an intuitive platform for friends to listen along to each other, without needing premium. Instead of needing to mess around with Facebook or Discord or any other third party accounts, with SpotAlong, friends can just download the app, add each other with their respective friend codes, and start listening along.',
    'Edu4Need': 'Edu4Need is a intuitive crowdfunding medium for both students in need, and donors. It allows students to create unique profiles on the app, and then allows donors to search for these profiles and subsequently help students in need. We believe that Edu4Need will be able to have a significant impact on the education of the less fortunate, one student at a time.',
    'Game Day Grill': 'Game Day Grill was created for the 2023-2024 Website Design Team BPA event. This is a mock restaurant website with a functional cart, reservation, payments and delivery system, utilizing various technologies such as SvelteKit and Prisma, and APIs, including Stripe and Google Maps Platform.',
    'Nixar Solutions': 'This brand website was developed for Nixar Solutions, a social media marketing company out of California. We used a modern design utilizing sans-serif fonts, grainy gradients, and locomotive scroll.'
};

type ProjectDetails = ProjectInfo & { largeImage: string, backgroundColor?: string, skills: string[], detailedDescription: string, projectURL: string, githubURL: string, images: string[] };
export const projectDetails: Record<string, ProjectDetails> = {
    'SpotAlong': { ...projects[0], largeImage: '/spotalong-background.png', skills: ['Python', 'Flask', 'PostgreSQL', 'Qt', 'Socket.IO', 'HTML', 'SCSS', 'JS', 'NSIS', 'Figma', 'Git'], detailedDescription: detailedDescriptions['SpotAlong'], projectURL: 'https://spotalong.github.io', githubURL: 'https://github.com/SpotAlong/SpotAlong-Client', images: [] },
    'Edu4Need': { ...projects[1], largeImage: '/edu4need-background.png', backgroundColor: '#FFFFFF', skills: ['Python', 'Flask', 'JWT', 'Dart', 'Flutter', 'SQLAlchemy', 'PostgreSQL', 'Figma', 'Google Maps Platform', 'Stripe'], detailedDescription: detailedDescriptions['Edu4Need'], projectURL: 'https://edu4need.com', githubURL: '', images: [] },
    'Game Day Grill': { ...projects[2], largeImage: '/game-day-grill-background.png', backgroundColor: '#0D0E10', skills: ['TypeScript', 'Svelte', 'SvelteKit', 'PostgreSQL', 'Prisma', 'HTML', 'SCSS', 'Figma', 'Google Maps Platform', 'Stripe', 'Figma'], detailedDescription: detailedDescriptions['Game Day Grill'], projectURL: 'https://game-day-grill.tech', githubURL: '', images: [] },
    'Nixar Solutions': { ...projects[3], largeImage: '/nixar.png', backgroundColor: '#000000', skills: ['TypeScript', 'Svelte', 'SvelteKit', 'HTML', 'SCSS', 'Figma', 'Vercel'], detailedDescription: detailedDescriptions['Nixar Solutions'], projectURL: 'https://nixar-sol.vercel.app', githubURL: '', images: [] }
};

export const occupations = ['web\xa0developer', 'software\xa0engineer', 'avid\xa0learner', 'passionate\xa0student'];

export const skills: Record<string, { name: string, certified?: boolean }[]>[] =
[
    {
        'Programming': [
            { name: 'Python', certified: true },
            { name: 'Java' },
            { name: 'JavaScript' },
            { name: 'Dart' },
            { name: 'TypeScript' }
        ],
        'Backend': [
            { name: 'Flask' },
            { name: 'SvelteKit' }
        ],
        'APIs': [
            { name: 'Google Maps Platform' },
            { name: 'Stripe' }
        ]
    },
    {
        'Frontend': [
            { name: 'Qt' },
            { name: 'SCSS' },
            { name: 'Figma' },
            { name: 'Flutter' },
            { name: 'Svelte' },
            { name: 'React' }
        ],
        'Database / ORMs': [
            { name: 'PostgreSQL' },
            { name: 'SQLAlchemy' },
            { name: 'Prisma' }
        ]
    }
];

export const weatherAPI = 'https://api.weather.com/v3/wx/forecast/fifteenminute?geocode=33.155373,-96.818733&units=e&language=en-US&format=json&apiKey=71f92ea9dd2f4790b92ea9dd2f779061';
